import React from 'react';
import { useSelector } from 'react-redux';

import './ActiveUsersLoading.scss';

const ActiveUsersLoading = () => {
  const locale = useSelector(state => state.locale.locale);
  return <span className="active-users-loading" role="status" aria-label={locale.activeUsers} aria-busy="true" />;
};

export default ActiveUsersLoading;
